"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectItems = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const FileSystemContext_1 = require("../FileSystemContext");
const isEqual_1 = (0, tslib_1.__importDefault)(require("lodash/isEqual"));
function useSelectItems(options = {}) {
    const { state, setState } = (0, react_1.useContext)(FileSystemContext_1.FileSystemContext);
    const [multiSelect, setMutliSelect] = (0, react_1.useState)({
        page: options.page
    });
    (0, react_1.useEffect)(() => {
        if (!(0, isEqual_1.default)(options.page, multiSelect.page)) {
            setMutliSelect(state => (Object.assign(Object.assign({}, state), { page: options.page })));
        }
    }, [options.page, multiSelect.page]);
    const handleItemClick = (0, react_1.useCallback)((item) => (event) => {
        event.stopPropagation();
        if (event.metaKey || event.ctrlKey || event.shiftKey)
            return;
        setMutliSelect(Object.assign(Object.assign({}, multiSelect), { activeItem: item }));
        setState(state => (Object.assign(Object.assign({}, state), { selectedItems: [item], activeItem: item })));
    }, [state.selectedItems]);
    const handleItemMouseDown = (0, react_1.useCallback)((item) => (event) => {
        let selectedItems = [];
        const items = multiSelect.page.slice();
        let previousSelectedItems = state.selectedItems.slice();
        let previousActiveItem = multiSelect.activeItem;
        if (event.ctrlKey || event.metaKey) {
            if (previousSelectedItems.indexOf(item) > -1 &&
                item.path !== previousActiveItem.path) {
                selectedItems = previousSelectedItems.filter(i => i.path !== item.path);
            }
            else {
                selectedItems = [...previousSelectedItems, item];
            }
        }
        else if (event.shiftKey && item.id !== previousActiveItem.id) {
            const activeCardIndex = items.findIndex(i => i.id === previousActiveItem.id);
            const itemIndex = items.findIndex(i => (0, isEqual_1.default)(i, item));
            const lowerIndex = Math.min(activeCardIndex, itemIndex);
            const upperIndex = Math.max(activeCardIndex, itemIndex);
            selectedItems = items.slice(lowerIndex, upperIndex + 1);
        }
        else if (previousSelectedItems.indexOf(item) > -1) {
            selectedItems = previousSelectedItems;
        }
        else {
            selectedItems = [item];
        }
        setMutliSelect(Object.assign(Object.assign({}, multiSelect), { activeItem: item }));
        setState(state => (Object.assign(Object.assign({}, state), { selectedItems, activeItem: item })));
    }, [
        state.selectedItems,
        options.page,
        multiSelect,
        multiSelect.page,
        setMutliSelect
    ]);
    const isSelected = (0, react_1.useCallback)((item) => state.selectedItems.some(i => i.path === item.path && i.id === item.id), [state.selectedItems]);
    const addSelected = (0, react_1.useCallback)((items) => {
        setState(state => (Object.assign(Object.assign({}, state), { selectedItems: [...state.selectedItems, ...items] })));
    }, [setState]);
    const removeSelected = (0, react_1.useCallback)((items) => {
        setState(state => {
            return Object.assign(Object.assign({}, state), { selectedItems: state.selectedItems.filter(item => !items.some(i => item.path === i.path && item.id === i.id)) });
        });
    }, [setState]);
    const setSelected = (0, react_1.useCallback)((selectedItems) => {
        setState(state => (Object.assign(Object.assign({}, state), { selectedItems })));
    }, [setState]);
    return {
        selectedItems: state.selectedItems,
        isSelected,
        addSelected,
        removeSelected,
        setSelected,
        handleItemMouseDown,
        handleItemClick,
        multiSelect,
        activeItem: state.activeItem
    };
}
exports.useSelectItems = useSelectItems;
//# sourceMappingURL=useSelectItems.js.map